// extracted by mini-css-extract-plugin
export var text = "_6k-0";